import { SopModuleType } from "./sopTypes";

export const sopModuleReducer = {
  resetSopModuleError: (state: SopModuleType) => {
    state.error = null;
  },
  resetSopModuleSuccess: (state: SopModuleType) => {
    state.success = null;
  },
  resetSopModuleFetching: (state: SopModuleType) => {
    state.fetching = false;
  },
  resetSopModuleMessage: (state: SopModuleType) => {
    state.message = "";
  },
  resetSopModuleListing: (state: SopModuleType) => {
    state.sopModuleList = [];
  },
  resetSopModuleListTotal: (state: SopModuleType) => {
    state.sopModuleTotalCount = 0;
  },
  resetSopModuleStatusCode: (state: SopModuleType) => {
    state.statusCode = null;
  },
  resetSingleSopDetails: (state: SopModuleType) => {
    state.singleSopDetails = {};
  },
  resetUniqueCheckFileNameMessage: (state: SopModuleType) => {
    state.uniqueCheckFileNameMessage = "";
  },
};
